// extracted by mini-css-extract-plugin
module.exports = {"main":"PlusIcon_main__LLzeX"};